import { css } from 'emotion';
import theme from 'site-react/theme';

const HeadingStyles = css`
  margin: 16px 24px;
  padding: 0;
  font-family: ${theme.font.family.default};
  font-size: ${theme.font.size.xs};
  font-weight: ${theme.font.weight.medium};
  text-transform: uppercase;
  color: ${theme.colors.neutral900};
`;

const HeadingLinkStyles = css`
  margin: 0;

  & > ul > li:last-child {
    padding: 0;
  }

  & > ul > li > a {
    padding: 16px 24px;
    font-family: ${theme.font.family.default};
    font-size: ${theme.font.size.xs};
    font-weight: ${theme.font.weight.medium};
    text-transform: uppercase;
    line-height: ${theme.lineHeight.xxl};
    color: ${theme.colors.neutral900};

    & > i {
      float: right;
      right: -2%;
      font-size: ${theme.font.size.lg};
      line-height: ${theme.lineHeight.reset};
    }
  }
`;

export { HeadingStyles, HeadingLinkStyles };
export default { HeadingStyles, HeadingLinkStyles };
